import { OnInit, Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  displayCookie: boolean = true;
  constructor(public cookieService: CookieService) { }
  ngOnInit() {
    if (this.cookieService.get('cookieConsent')) {
      this.displayCookie = false;
    }
  }

  acceptCookies() {
    // Définissez un cookie pour enregistrer l'acceptation des cookies
    this.cookieService.set('cookieConsent', 'true', 7);
    this.displayCookie = false;
  }

}
